import Cookies from 'js-cookie'
import {DOMAIN} from '@/config'

const domain = DOMAIN
const accountKey = 'login-id'

export function getLoginId () {
  if (process.env.NODE_ENV === 'development') {
    return Cookies.get(accountKey)
  } else {
    return Cookies.get(accountKey, { domain })
  }
}

export function setLoginId (token) {
  if (process.env.NODE_ENV === 'development') {
    Cookies.set(accountKey, token)
  } else {
    Cookies.set(accountKey, token, { domain })
  }
}

export function removeLoginId () {
  if (process.env.NODE_ENV === 'development') {
    Cookies.remove(accountKey)
  } else {
    Cookies.remove(accountKey)
    Cookies.remove(accountKey, { domain })
  }
}



// WEBPACK FOOTER //
// ./src/utils/loginId.js